import { render, staticRenderFns } from "./MdAlert.vue?vue&type=template&id=72472509&"
import script from "./MdAlert.vue?vue&type=script&lang=js&"
export * from "./MdAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports